import {IFilterFunction} from "angular";
import {
    WorkingOrderListOrderBy,
} from "../components/orders/models/WorkingOrderListOrderBy";

export const WorkingOrderListOrderByPipe = "workingOrderListOrderBy";

export function workingOrderListOrderByPipe(): IFilterFunction {
    return (value: WorkingOrderListOrderBy | null) => {
        if (value == null) {
            return null;
        } else {
            return `orders-order-by.${value}`;
        }
    };
}
